export const DASHBOARD_LIMIT = Infinity

export const breakpoints = { lg: 1000, md: 900, sm: 768, xs: 580, xxs: 200 }
export const cols = { lg: 6, md: 5, sm: 4, xs: 3, xxs: 2 }
